<template>
  <div>
    <el-form ref="setTargetTemp" label-width="90px" label-position="left" :model="model">
      <!-- 语音触发 -->
      <template v-if="shipType === 'VOICE'">
        <el-form-item label="唤醒词" prop="voiceWord" :rules="{ required: true, message: '请填写唤醒词' }">
          <el-input v-model.trim="model.voiceWord" :disabled="disabled" placeholder="多个唤醒词英文逗号分隔"/>
        </el-form-item>
        <el-form-item label="反馈提示" prop="feedBack" :rules="{ maxLength: 255 }">
          <el-input :disabled="disabled" v-model.trim="model.feedBack" placeholder="当用户说出正确唤醒词，系统将回复该提示"/>
        </el-form-item>
      </template>
      <!-- 通用 -->
      <el-form-item label="主交互" prop="targetTempId">
        <el-select
          v-model="model.targetTempId"
          ref="targetTemp"
          filterable
          placeholder="请选择模板"
          :disabled="disabled"
          @change="(value) => { handleTempChange(value, 'normalData') }"
        >
          <el-option :value="-1" label="无"></el-option>
          <el-option :value="0" label="自定义(打开应用)"></el-option>
          <el-option
            v-for="(opt, optIndex) in eventTempList"
            :key="optIndex"
            :value="opt.tempId"
            :label="opt.tempName"
          >{{ opt.tempName }}</el-option>
        </el-select>
      </el-form-item>
      <template v-if="model.targetTempId !== -1">
        <TargetEventBase
          mode="normal"
          :temp-model="tempModel"
          :disabled="disabled"
          :partner-id="partnerId"
          :model="model.normalData"
        />
        <el-form-item label="异常处理">
          <el-radio-group v-model="model.exception" @change="handleChangeException">
            <el-radio-button label="yes" :disabled="disabled">是</el-radio-button>
            <el-radio-button label="no" :disabled="disabled">否</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <template v-if="model.exception === 'yes'">
          <el-form-item label="">
            <el-select
              v-model="model.excTargetTempId"
              :disabled="disabled"
              filterable
              placeholder="请选择模板"
              @change="(value) => { handleTempChange(value, 'exceptionData') }"
            >
              <el-option :value="-1" label="无"></el-option>
              <el-option :value="0" label="自定义(打开应用)"></el-option>
              <el-option
                v-for="(opt, optIndex) in eventTempList"
                :key="optIndex"
                :value="opt.tempId"
                :label="opt.tempName"
              >{{ opt.tempName }}</el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="model.excTargetTempId !== -1" label="">
            <TargetEventBase
              mode="exception"
              :temp-model="excTempModel"
              :disabled="disabled"
              :partner-id="partnerId"
              :model="model.exceptionData"
            />
          </el-form-item>
        </template>
      </template>
    </el-form>
  </div>
</template>

<script>
import TargetEventBase from './TargetEventBase.vue'

export default {
  components: {
    TargetEventBase
  },
  props: {
    shipType: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    partnerId: { type: Number, default: 0 },
    model: { type: Object, default: () => ({}) },
    eventTempList: { type: Array, default: () => [] },
  },
  data() {
    return {
      tempModel: {},
      excTempModel: {}
    }
  },
  watch: {
    'model.targetTempId'() {
      this.initTempModel()
    },
    'model.excTargetTempId'() {
      this.initTempModel()
    }
  },
  async mounted() {
    this.initTempModel()
  },
  methods: {
    handleTempChange(tempId, field) {
      const curTemp = this.eventTempList.find(temp => temp.tempId === tempId)
      if (tempId <= 0) {
        this.model[field] = {
          doWhat: 'startActivity',
          packageName: '',
          byWhat: tempId === 0 ? 'action' : 'web',
          byValue: '',
          paramsList: [],
          privateParams: []
        }
      } else {
        this.model[field] = {
          doWhat: curTemp.doWhat,
          packageName: curTemp.packageName,
          byWhat: curTemp.byWhat,
          byValue: curTemp.byValue,
          text: curTemp.doWhat === 'skipAd' ? curTemp.text : undefined,
          showTime: curTemp.doWhat === 'skipAd' ? curTemp.showTime : undefined,
          paramsList: this.getTempParams(curTemp.paramsList),
          privateParams: this.getTempParams(curTemp.privateParams)
        }
      }
      if (field === 'normalData') {
        // 无->无交互事件4， 自定义->默认跳转1，其余取模板配置
        const targetEventType = tempId === -1 ? 4 : (tempId === 0 ? 1 : curTemp.tempType)
        this.$emit('temp-change', targetEventType)
        this.$nextTick(() => {
          this.$refs.targetTemp && this.$refs.targetTemp.blur()
        })
      }
    },
    getTempParams(listJson = '') {
      const params = listJson ? JSON.parse(listJson) : []
      return params.map(item => {
        return {
          key: item.key,
          value: item.defaultValue,
          placeholder: item.holder
        }
      })
    },
    handleChangeException(val) {
      if (val === 'no') {
        this.model.excTargetTempId = -1
        this.handleTempChange(-1, 'exceptionData')
      }
    },
    initTempModel() {
      if (this.model.targetTempId > 0) {
        this.tempModel = this.eventTempList.find(temp => temp.tempId === this.model.targetTempId)
      } else {
        this.tempModel = {}
      }
      if (this.model.excTargetTempId > 0) {
        this.excTempModel = this.eventTempList.find(temp => temp.tempId === this.model.excTargetTempId)
      } else {
        this.excTempModel = 0
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.el-form .el-form-item
  margin-bottom 16px
</style>
